import React from "react";
import { Text, Flex, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { t } from "@lang/i18n";

const IncompleteProfile = () => {
  return (
    <Flex flexDir="column" justifyContent="center" alignItems="center" mt="16.5rem">
      <Text fontSize="1.25rem" fontWeight="600" textColor="gray.borders" w="37.5rem" textAlign="center" mb="2.56rem">
        { t('company.search_candidates.profile_incompleted') }
      </Text>

      <Link to="/company/profile">
        <Button bg="green.main" borderRadius="24px" color="white" w="16.25rem" mt="1.625rem" textAlign="center"
                _hover={{bg: "green.light"}}>
          { t('company.search_candidates.complete_profile') }
        </Button>
      </Link>
    </Flex>
  );
};

export default IncompleteProfile;